import React from 'react';
import '../../styles/GridCard.css';

type Card = {
    image: string;
    title: string;
    description: string;
    features?: string[];
};

type GridCardProps = {
  sectionHeading: string;
  gridCards: Card[];
};

// @ts-ignore
const imagesContext = require.context('../../assets/serviceDetails/grid-card-Images', false, /\.(png|jpe?g|svg)$/);

const getImage = (imageName: string): string => {
  try {
    return imagesContext(`./${imageName}`);
  } catch {
    console.warn(`Image not found: ${imageName}`);
    return '';
  }
};

const GridCard: React.FC<GridCardProps> = ({ sectionHeading, gridCards }) => {
  return (
    <section className="gridCard-section">
      <div className="gridCard-content">
       <p className="sections-title gridCard-title">{sectionHeading}</p>

        <div
          className={`gridcard-grid ${
            gridCards.length === 2 ? 'two-columns' : ''
          }`}
        >
          {gridCards.map((card, index) => (
            <div
              key={index}
              className="gridcard-item"
            >
              <div className="gridcard-number">
                {String(index + 1).padStart(2, '0')}
              </div>
              
              {/* Card Content */}
              <div className="gridcard-content">
                {/* Image */}
                <div className="gridcard-image-container">
                <img src={getImage(card.image)} alt={card.title} className="slider-image gridcard-image" />
                </div>
                
                {/* Title */}
                <h3 className="gridcard-card-title">
                  {card.title}
                </h3>
                
                {/* Description */}
                <p className="gridcard-description">
                  {card.description}
                </p>
                
                {/* Features */}
                {card.features && (
                  <div className="gridcard-features">
                    <ul className="use-case-features">
                    {card.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="use-case-feature">
                        {feature}
                      </li>
                    ))}
                  </ul>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GridCard;
